import React from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import { getSafelistSummaryMap } from 'services/safelists/getters';
import { TransformationType } from 'shared/types/transformation';

import { TransformationValueWrapperProps } from './types';

const StyledTransformationValue = styled.span``;

const TransformationValueWrapper = ({
  type,
  value,
}: TransformationValueWrapperProps) => {
  const safelistMap = useSelector(getSafelistSummaryMap);

  if (type === TransformationType.SAFELIST_LIBRARY) {
    return (
      <StyledTransformationValue>
        {safelistMap[value]?.name}
      </StyledTransformationValue>
    );
  }

  return (
    <StyledTransformationValue>{value}</StyledTransformationValue>
  );
};

export { TransformationValueWrapper };
